import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/users';
import Users from './UsersCrear';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.users,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(Users);
